import React from "react";

import { useCreateCostCenters } from "@/queries/cost-centers/create";
import { useTranslation } from "react-i18next";
import { useAccountsDataContext } from "@/features/settings/accounts-table/accounts-data-provider";
import { useAccountsTableInstanceContext } from "@/features/settings/accounts-table/table-instance-provider";
import { useCostCentersTableInstanceContext } from "@/features/settings/cost-centers-table/table-instance-provider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

const NewCostCenterForm = ({}) => {
  const { t } = useTranslation();
  const { onGlobalFilterChange } = useCostCentersTableInstanceContext();
  const { createCostCenter } = useCreateCostCenters();
  const [newCostCenter, setNewCostCenter] = React.useState({
    identifier: "",
    name: "",
    description: "",
  });

  const handleInputChange = (field: string, value: string) => {
    if (field === "identifier") {
      const allowedCharsRegex = /^[a-zA-Z0-9\s]*$/;
      if (!allowedCharsRegex.test(value)) {
        return;
      }
    }

    onGlobalFilterChange(String(value));
    setNewCostCenter({
      ...newCostCenter,
      [field]: value,
    });
  };

  const handleSaveCostCenter = async () => {
    if (!newCostCenter.identifier || !newCostCenter.name) return;
    createCostCenter(newCostCenter);
    setNewCostCenter({
      identifier: "",
      name: "",
      description: "",
    });
    onGlobalFilterChange("");
  };

  return (
    <div className="flex space-x-2 mb-2 items-center">
      <Input
        className="w-[130px]"
        placeholder={t("cost_center_abrv")}
        name="identifier"
        value={newCostCenter.identifier}
        onChange={(e) => handleInputChange("identifier", e.target.value)}
      />
      <Input
        className="w-[300px]"
        placeholder={t("name")}
        name="name"
        multiple
        value={newCostCenter.name}
        onChange={(e) => handleInputChange("name", e.target.value)}
      />
      <Input
        className="h-10 bg-white"
        placeholder={t("description")}
        name="description"
        value={newCostCenter.description}
        onChange={(e) => handleInputChange("description", e.target.value)}
      />

      <Button onClick={handleSaveCostCenter}>{t("save")}</Button>
    </div>
  );
};

export default NewCostCenterForm;
